<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-multiple</v-icon> <span>{{$t('my_profile.title')}}</span>
      </h1>

      <div class="mt-16">
        <v-progress-linear v-if="loading"
          indeterminate
          class="global-loader"
        ></v-progress-linear>

        <template v-if="loading">
          <v-row>
            <v-col cols="12" md="6">
              <v-skeleton-loader
                type="text"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="6">
              <v-skeleton-loader
                type="text"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-skeleton-loader
                type="text"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-skeleton-loader
                type="text"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mt-6" align="center" justify="space-around">
            <v-skeleton-loader
                type="button"
              ></v-skeleton-loader>
          </v-row>
        </template>
        <user v-else method="update" :user="user"></user>
      </div>
  </section>
</template>
<script>
import User from '@/components/users/User'
import ClientUsers from "@/api/ClientUsers.js";

export default {
  components: {
    User
  },
  beforeCreate(){
    document.title = "Report Lake- " + this.$t('my_profile.title_plural');
  },
  data: () => ({
      user: {},
      loading:true
  }),
  async mounted(){
    if(this.$route.name != 'my-profile'){
      if(!this.$root.session.hasPermission(["super", "users.update"]) && this.$root.session.id != this.$route.params.id) {
        
        this.$router.push('/admin');
      }
    }

    await ClientUsers.find(this.$route.params.id == undefined ? this.$root.session.id : this.$route.params.id, this.$route.params.id == undefined ? this.$session.get('domain') : null).then(({data}) => { this.user = data; this.loading = false;});
    
  },
  methods:{
    
  },
  computed: {
    crumbs: function() {
      if(this.$route.name == 'my-profile'){
        return [      
          {
            text: this.$t('globals.definitions'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/settings/general',
            exact: true,
          },
          {
          text: this.$t('my_profile.my_account'),
          disabled: true,
          to: window.location.href,
          exact: true,
          }
        ];
      }


      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('menu.users_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/accesses/users',
          exact: true,
        },
        {
          text: this.$t('my_profile.title'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
